/* OPQ Product page client behaviour:
   - Variant picker accordion (custom-styled <select> alternative)
   - Mobile slider dot indicators
   - AJAX add-to-cart with brief in-button feedback
   No external dependencies on the legacy iggc.js. */

function initVariantPicker(root) {
  const wrapper = root.querySelector('[data-opq-product-variant]');
  if (!wrapper) return;
  const toggle = wrapper.querySelector('[data-opq-product-variant-toggle]');
  const label  = wrapper.querySelector('[data-opq-product-variant-label]');
  const list   = wrapper.querySelector('[data-opq-product-variant-list]');
  const idIn   = root.querySelector('#opq-product-variant-id');
  if (!toggle || !label || !list || !idIn) return;

  toggle.addEventListener('click', () => {
    wrapper.classList.toggle('is-open');
  });

  list.querySelectorAll('[data-opq-product-variant-option]').forEach((opt) => {
    opt.addEventListener('click', () => {
      const id = opt.dataset.variantId;
      const isUnavailable = opt.dataset.unavailable === 'true';
      idIn.value = id;
      label.textContent = opt.textContent.trim();
      wrapper.classList.remove('is-open');

      const cta = root.querySelector('[data-opq-product-cta]');
      if (cta) {
        cta.disabled = isUnavailable;
        const ctaLabel = cta.querySelector('[data-opq-product-cta-label]');
        if (ctaLabel) ctaLabel.textContent = isUnavailable ? 'Sold out' : 'Add to cart';
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) wrapper.classList.remove('is-open');
  });
}

function initSliderDots(root) {
  const slider = root.querySelector('[data-opq-product-slider]');
  const dots = root.querySelectorAll('[data-opq-product-dots] .opq-product__dot');
  if (!slider || dots.length === 0) return;

  const updateActive = () => {
    const i = Math.round(slider.scrollLeft / slider.offsetWidth);
    dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
  };

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      slider.scrollTo({ left: i * slider.offsetWidth, behavior: 'smooth' });
    });
  });

  slider.addEventListener('scroll', updateActive, { passive: true });
  updateActive();
}

function initAddToCart(root) {
  const form = root.querySelector('.opq-product__form');
  const cta  = root.querySelector('[data-opq-product-cta]');
  const note = root.querySelector('[data-opq-product-cta-note]');
  if (!form || !cta) return;

  form.addEventListener('submit', async (e) => {
    /* If a variant picker exists and the user hasn't picked, bounce them
       into the picker instead of submitting. */
    const variantWrapper = root.querySelector('[data-opq-product-variant]');
    const label = variantWrapper?.querySelector('[data-opq-product-variant-label]');
    if (variantWrapper && label && /select size/i.test(label.textContent)) {
      e.preventDefault();
      variantWrapper.classList.add('is-open');
      variantWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    e.preventDefault();
    const ctaLabel = cta.querySelector('[data-opq-product-cta-label]');
    const originalLabel = ctaLabel ? ctaLabel.textContent : 'Add to cart';
    cta.disabled = true;
    if (ctaLabel) ctaLabel.textContent = 'Adding…';

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
      });
      if (!res.ok) throw new Error('Add to cart failed');
      const data = await res.json();

      cta.classList.add('is-feedback');
      if (ctaLabel) ctaLabel.textContent = 'Added';
      if (note) {
        const cartRes = await fetch('/cart.js').then((r) => r.json());
        note.textContent = `${cartRes.item_count} item${cartRes.item_count === 1 ? '' : 's'} in cart · `;
        const link = document.createElement('a');
        link.href = '/cart';
        link.textContent = 'view cart';
        link.style.color = '#000';
        link.style.borderBottom = '0.5px solid rgba(0,0,0,0.30)';
        link.style.textDecoration = 'none';
        note.appendChild(link);
        note.hidden = false;
      }

      setTimeout(() => {
        cta.classList.remove('is-feedback');
        cta.disabled = false;
        if (ctaLabel) ctaLabel.textContent = originalLabel;
      }, 2200);
    } catch (err) {
      cta.disabled = false;
      if (ctaLabel) ctaLabel.textContent = 'Try again';
      console.error('[opq-product] add to cart failed', err);
    }
  });
}

document.querySelectorAll('.opq-product').forEach((root) => {
  initVariantPicker(root);
  initSliderDots(root);
  initAddToCart(root);
});
